import React from 'react';
import { Box, Typography } from '@mui/material';

export default function AvatarBadge({ initials, size = 32, textVariant = 'caption', sx = {} }) {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        bgcolor: theme => theme.palette.mode === 'dark' ? theme.bruno.colors.inactive : '#1a242d',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid rgba(255,255,255,0.35)',
        ...sx,
      }}>
      <Typography variant={textVariant} sx={{ color: 'common.white', fontWeight: 700, lineHeight: 1 }}>
        {initials}
      </Typography>
    </Box>
  );
}
